import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { LayoutService } from '../../layout/services/layout.service';
import { ServiceResult } from '../interfaces/service-result';
import { RuntimeConfigService } from './runtime-config.service';

@Injectable({
  providedIn: 'root'
})
export class FormDataUploadService {

  http = inject(HttpClient);
  layoutService = inject(LayoutService);
  runtimeConfig = inject(RuntimeConfigService);

  uploadCompleted = new Subject<boolean>();
  uploadError: boolean = false;
  uploadErrorMsg: string = '';

  constructor() { }

  public uploadFormData(endpoint: string, data: FormData, withFiles: boolean = false, showProgress: boolean = false, progressTitle: string = ''): Observable<boolean> {

    this.uploadError = false;
    this.uploadErrorMsg = '';

    /**
     * uploading with files -> observer for progress
     */
    if (withFiles) {
      this.http.post(this.runtimeConfig.dataBackend + endpoint, data, {
        reportProgress: true,
        observe: 'events'
      }).subscribe({
        next: (event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              if (event.total) {
                this.layoutService.progressValue.set(Math.round(100 * event.loaded / event.total));
              }
              break;
            case HttpEventType.Response:
              this.uploadCompleted.next(true);
              break;
          }
        },
        error: err => {
          this.uploadError = true;
          this.uploadErrorMsg = err.message;
          this.uploadCompleted.next(false);
        }
      });
    } else {
      this.http.post<ServiceResult>(this.runtimeConfig.dataBackend + endpoint, data).subscribe({
        next: (result) => {
          if (result.status) {
            this.uploadCompleted.next(true);
          } else {
            this.uploadError = true;
            this.uploadErrorMsg = result.message;
          }
        },
        error: (err) => {
          this.uploadError = true;
          this.uploadErrorMsg = err.message;
          this.uploadCompleted.next(false);
        },
      })
    }

    return this.uploadCompleted.asObservable();
  }

}
